import { render, staticRenderFns } from "./PwaNewVehicle.vue?vue&type=template&id=38f0dd70&scoped=true"
import script from "./PwaNewVehicle.vue?vue&type=script&lang=js"
export * from "./PwaNewVehicle.vue?vue&type=script&lang=js"
import style0 from "./PwaNewVehicle.vue?vue&type=style&index=0&id=38f0dd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f0dd70",
  null
  
)

export default component.exports